import { useState } from "react";
import { makeStyles } from "tss-react/mui";
import {
  MiCard,
  MiFieldSet,
  MiMenu,
  MiModalConfirm,
} from "@miplatform/components";
import { BUTTON_LABELS, ICONS_WEB, MODAL_TITLES } from "@miplatform/constants";
import { MiTHEME } from "@miplatform/theme";
import * as mdi from "@mdi/js";
import { Box } from "@mui/material";
import { StepTemplateModal } from "./StepTemplateModal";

export const StepTemplateCard = ({ item, handleDelete, updateItem }) => {
  const { classes } = useStyles();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [editing, setEditing] = useState(false);

  const handleShowConfirmModal = () => setShowConfirmModal(true);
  const handleEditing = () => setEditing(true);

  const onHandleDelete = () => {
    setShowConfirmModal(false);
    handleDelete({
      modifiedOn: item.modifiedOn,
      id: item.id,
    });
  };

  const onHandleUpdate = (data) => {
    updateItem({ ...data, id: item.id });
  };

  const renderMenu = () => {
    return (
      <Box>
        <MiMenu
          data={[
            {
              label: BUTTON_LABELS.EDIT,
              icon: mdi[ICONS_WEB.PENCIL],
              color: MiTHEME.palette.grey.main,
              action: handleEditing,
            },
            {
              label: BUTTON_LABELS.DELETE,
              icon: mdi[ICONS_WEB.TRASH_CAN],
              color: MiTHEME.palette.red.main,
              action: handleShowConfirmModal,
            },
          ]}
          data-testid="step-template-menu"
        />
      </Box>
    );
  };

  return (
    <Box>
      <MiCard
        className={classes.itemCardContainer}
        title={item.title}
        rightComponent={renderMenu()}
      >
        <MiFieldSet
          fieldset={[
            { field: "description", label: "Description" },
            { field: "areaName", label: "Area" },
            {
              field: "canBeNotApplicable",
              label: "CanNA",
              valueGetter: (row) => (row.canBeNotApplicable ? "Yes" : "No"),
            },
            {
              field: "isRequired",
              label: "Required",
              valueGetter: (row) => (row.isRequired ? "Yes" : "No"),
            },
            {
              field: "requiresPhoto",
              label: "Requires Photo",
              valueGetter: (row) => (row.requiresPhoto ? "Yes" : "No"),
            },
            {
              field: "requiresVideo",
              label: "Requires Video",
              valueGetter: (row) => (row.requiresVideo ? "Yes" : "No"),
            },
          ]}
          showNulls
          row={item}
        />
      </MiCard>
      {editing && (
        <StepTemplateModal
          open={editing}
          onClose={() => setEditing(false)}
          onSubmit={onHandleUpdate}
          templateItem={item}
        />
      )}
      {showConfirmModal && (
        <MiModalConfirm
          title={MODAL_TITLES.DELETE}
          open={showConfirmModal}
          description={`Are you sure you want to delete ${item.title} - ${item.description}`}
          handleNegative={() => setShowConfirmModal(false)}
          handlePositive={onHandleDelete}
          textPositive={BUTTON_LABELS.DELETE}
        />
      )}
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  itemCardContainer: {
    border: `1px solid ${theme.palette.grey.accent}`,
    backgroundColor: theme.palette.common.white,
    margin: theme.spacing(2, 0),
    padding: 8,
    borderRadius: 8,
  },
}));
